export default "__VITE_ASSET__DuCEhzCE__"